import { createAction, props } from '@ngrx/store';

export const saveSidenavConfig = createAction(
  '[SidenavConfig Component] Save',
  props<{ sidenavConfigData: any }>()
);

export const loadSidenavConfig = createAction('[SidenavConfig Component] Load');
